import { gql } from '@apollo/client';

export const CREATE_TRUSTS_USER_MUTATION = gql`
  mutation CreateTrustsUser($trustsUserCreateDto: TrustsUserCreateDto!) {
    createTrustsUser(trustsUserCreateDto: $trustsUserCreateDto) {
      email
      status
      enabled
      createdDate
    }
  }
`;
